import { Action } from '@ngrx/store';

import { ScreeningErrorsPayload } from 'store/models/screening.models';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 */
export enum ErrorActionTypes {
  SET_SCREENING_ERROR = 'SET_SCREENING_ERROR',
  REMOVE_SCREENING_ERROR = 'REMOVE_SCREENING_ERROR'
}

export type ErrorActions
  = SetScreeningError
  | RemoveScreeningError;

export class SetScreeningError implements Action {
  readonly type: ErrorActionTypes = ErrorActionTypes.SET_SCREENING_ERROR;
  constructor(public payload: ScreeningErrorsPayload = null) { }
}

export class RemoveScreeningError implements Action {
  readonly type: ErrorActionTypes = ErrorActionTypes.REMOVE_SCREENING_ERROR;
  constructor(public payload: ScreeningErrorsPayload = null) { }
}
